import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Authorize } from '@/core';
import { Button } from 'antd';
import React from 'react';
import { DistrictProvider } from '../context';
import { DetailDistrict } from './Form';
import { DistrictTable } from './List/DistrictTable';
import { PERMISSIONS } from '@/contants';

export const DistrictScreen: React.FC = () => {
  const { open, handleClose, setOpen, handleClickCreate } = useHandleActionItem();

  return (
    <DistrictProvider>
      <div className='bg-white py-4 px-4 flex flex-col flex-wrap'>
        <div className='ml-auto'>
          <Button
            type='primary'
            size='middle'
            onClick={() => handleClickCreate()}
            className='rounded'
          >
            + Create
          </Button>
        </div>
        <div className='w-full mt-2'>
          <DistrictTable />
          <DetailDistrict open={open} handleClose={handleClose} setOpen={setOpen} />
        </div>
      </div>
    </DistrictProvider>
  );
};

export const DistrictList = Authorize(DistrictScreen, PERMISSIONS.DISTRICTS.VIEW);
